var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61861 15V4.81818H5.15483V9.2429H10.2308V4.81818H11.772V15H10.2308V10.5604H5.15483V15H3.61861ZM14.5893 13.7372C14.3175 13.7372 14.0839 13.6411 13.8883 13.4489C13.6928 13.2533 13.595 13.018 13.595 12.7429C13.595 12.4711 13.6928 12.2391 13.8883 12.0469C14.0839 11.8513 14.3175 11.7536 14.5893 11.7536C14.8611 11.7536 15.0948 11.8513 15.2903 12.0469C15.4859 12.2391 15.5836 12.4711 15.5836 12.7429C15.5836 12.9252 15.5372 13.0926 15.4444 13.245C15.3549 13.3942 15.2356 13.5135 15.0865 13.603C14.9373 13.6925 14.7716 13.7372 14.5893 13.7372ZM14.5893 8.63636C14.3175 8.63636 14.0839 8.54025 13.8883 8.34801C13.6928 8.15246 13.595 7.91714 13.595 7.64205C13.595 7.37027 13.6928 7.13826 13.8883 6.94602C14.0839 6.75047 14.3175 6.6527 14.5893 6.6527C14.8611 6.6527 15.0948 6.75047 15.2903 6.94602C15.4859 7.13826 15.5836 7.37027 15.5836 7.64205C15.5836 7.82434 15.5372 7.99171 15.4444 8.14418C15.3549 8.29332 15.2356 8.41264 15.0865 8.50213C14.9373 8.59162 14.7716 8.63636 14.5893 8.63636Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeight);
export default ForwardRef;